module.exports = __webpack_public_path__ + "img/10.623bfdd8.jpg";